import { WindowsOpenRequest } from "../../../../domain/localhost/items";
import { IWindowsOpenRequestBean } from "../beans";

export class WindowsOpenRequestTranslator {
  static toWindowsOpenRequestBean(request: WindowsOpenRequest): IWindowsOpenRequestBean {
    if (!request) { return null; }
    return {
      urls: request.urls,
    };
  }
}
